import React, { Component } from 'react';

import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import {initNavbarState} from 'actions/navbar.js';
import PasswordChanged from './PasswordChanged.js'

class PasswordChangedContainer extends Component {

    constructor(props){
		super(props);
        var urlParams = queryString.parse(this.props.location.search);
        console.log('PasswordChangedContainer params=',urlParams);
		this.state = {params:urlParams};    
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:false, title:'', backButtonEnable:false}));
    }


    render() {
      return (
            <PasswordChanged params={this.state.params}  />
      );
  }
}

export default withRouter(connect()(PasswordChangedContainer));



// WEBPACK FOOTER //
// ./src/modules/authentication/PasswordChangedContainer.js